module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "setstar"
  }, _vm._l((_vm.visualizationSetstars), function(setstar, index) {
    return _c('circle', {
      key: index,
      attrs: {
        "cx": setstar.positionX,
        "cy": -setstar.positionY,
        "fill": _vm.fill(Math.round(setstar.setstar)),
        "r": "1.65",
        "fill-opacity": "0.7"
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d276e9a4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/layer/setstar.vue
// module id = 768
// module chunks = 0